/**
 * a project
 * @example {id: 'Internal', projectName: 'Internal tasks', lead: 'aandres'}
 */

export class Project {
    //properties: id	projectName	lead_0	lead_1	lead_2	lead_3	lead_4	startDate	endDate
    id: string = "";
    projectName: string = "";
    lead_0: string = "";
    lead_1: string = "";
    lead_2: string = "";
    lead_3: string = "";
    lead_4: string = "";
    /** @type {Date} */
    startDate: Date | null = null;
    /** @type {Date} */
    endDate: Date | null = null;
    project_status_id: string = "";
    keywords: string[] = [];

    constructor(data: Partial<Project> = {}) {
        this.id = data.id || '';
        this.projectName = data.projectName || '';
        this.lead_0 = data.lead_0 || '';
        this.lead_1 = data.lead_1 || '';
        this.lead_2 = data.lead_2 || '';
        this.lead_3 = data.lead_3 || '';
        this.lead_4 = data.lead_4 || '';
        this.startDate = data.startDate ? new Date(data.startDate) : null;
        this.endDate = data.endDate ? new Date(data.endDate) : null;
        this.project_status_id = data.project_status_id || '';
        this.keywords = data.keywords || [];
    }

    IsActive(): boolean {
        return this.project_status_id != "closed"
    }
}

// this is now my project muhahaha 	(•-•)⌐